export default "__VITE_ASSET__gxy81dib__"